import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    if (sessionStorage.getItem('browser_info_sent')) return;

    this._sendBrowserInfo();
  }

  _sendBrowserInfo() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch('/analytics/browser_info', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        browser_info: {
          platform: navigator.platform,
          dpr: window.devicePixelRatio,
          language: navigator.language,
          user_agent: navigator.userAgent,
          screen: { width: screen.width, height: screen.height },
          viewport: { width: window.innerWidth, height: window.innerHeight }
        }
      })
    }).then(response => {
      if (response.ok) {
        sessionStorage.setItem('browser_info_sent', 'true');
      }
    }).catch(() => {
      // Silently fail
    });
  }
}
